exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-fingo-js": () => import("./../../../src/pages/fingo.js" /* webpackChunkName: "component---src-pages-fingo-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-manulife-js": () => import("./../../../src/pages/manulife.js" /* webpackChunkName: "component---src-pages-manulife-js" */),
  "component---src-pages-purolator-js": () => import("./../../../src/pages/purolator.js" /* webpackChunkName: "component---src-pages-purolator-js" */),
  "component---src-pages-vysio-js": () => import("./../../../src/pages/vysio.js" /* webpackChunkName: "component---src-pages-vysio-js" */)
}

